/**
 * Validate email
 *
 * @param email
 * @returns {boolean}
 */
export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const recaptchaToken = (action) => {
 return new Promise((resolve) => {
     window.grecaptcha.ready(async () => {
        const token = await window.grecaptcha.execute('6LfD__MUAAAAAOMDGONgJTM7qVN9VSKeyKqlv1mr', {action: action});
        resolve(token);
      });
  });
}